import React, { FC } from 'react';
import { Collapse } from 'common/collapse';
import { formatPatent } from 'global/utils/plate/patente';
import { ViewsProps } from '../views.types';
import { FileDetails } from './file-details';
import { DocumentsList } from './documents-list';

import styles from './styles.module.scss';

export const MobileView: FC<ViewsProps> = ({ detailInfo, isVehicularCheckPoint, onDelete }) => (
  <div className={styles.mobileContainer}>
    <h3 className={styles.mobileContainerTitle}>Vehículo: {formatPatent(detailInfo?.vehiculo?.patente)}</h3>

    <Collapse title="DATOS GENERALES">
      <FileDetails detailInfo={detailInfo} isVehicularCheckPoint={isVehicularCheckPoint} />
    </Collapse>

    <Collapse title={`DOCUMENTOS (${detailInfo?.documents?.length || 0})`}>
      <DocumentsList documents={detailInfo?.documents} onDelete={onDelete} />
    </Collapse>
  </div>
);
